import React, { useState, useEffect } from "react";
import ChildEventStore from "./ChildEventStore";

const EventsAddToBasket = (props) => {
  const epreuve = props;
  //  localStorage.clear();
  const localBasket = localStorage.getItem("basket");
  const [basket, setBasket] = useState(localBasket);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("basket"));
    if (storedData) {
      setBasket(storedData);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("basket", JSON.stringify(basket));
  }, [basket]);

  const addEvent = () => {
    setBasket((prevData) => [
      ...prevData,
      { id: epreuve.id, name: epreuve.name },
    ]);
  };

  const removeEvent = (id) => {
    setBasket((prevData) => prevData.filter((item) => item.id !== id));
  };
  return (
    <div>
      <ChildEventStore
        epreuve={epreuve}
        addEvent={addEvent}
        removeEvent={removeEvent}
      />
    </div>
  );
};

export default EventsAddToBasket;
